export default __webpack_public_path__ + "static/media/policyModal.38070f61.png";